import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function equalToValidator(
  matchToControlName: string,
  message: string,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) {
      return null;
    }

    const matchToControl = control.parent.get(matchToControlName);
    if (!matchToControl) {
      return null;
    }

    const isMatching = control.value === matchToControl.value;
    return isMatching
      ? null
      : { equalTo: { matchingControl: matchToControlName, message: message } };
  };
}
